import { render, staticRenderFns } from "./GraphDetail50.vue?vue&type=template&id=0df6585f&scoped=true"
import script from "./GraphDetail50.vue?vue&type=script&lang=js"
export * from "./GraphDetail50.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df6585f",
  null
  
)

export default component.exports